import BasicLayout from '@/layouts/BasicLayout';
/**
 * 专题-模块
 */

var special = {
  path: '/brandIndex',
  redirect: '/brandIndex',
  component: BasicLayout,
  children: [{
    path: 'makeDraw',
    name: 'MakeDraw',
    redirect: {
      name: 'MakeDraw2'
    }
  }]
};
export default special;